export default "__VITE_ASSET__CIb0LmlI__"